import { apiClient } from './client';
import { ClientePublico } from '../types';

export function identificarClientePublico(tenantId: string, telefone: string): Promise<ClientePublico | null> {
  return apiClient
    .post(`/publico/clientes/${tenantId}/identificar`, { telefone })
    .then((res) => res.data.cliente);
}
